import { Component } from '@angular/core';

@Component({
  selector: 'app-howwecanhelpcontactus',
  templateUrl: './howwecanhelpcontactus.component.html',
  styleUrl: './howwecanhelpcontactus.component.scss'
})
export class HowwecanhelpcontactusComponent {

}
